// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  background-color: #0d707e;
  color: white;
  padding: 20px 15px;
  width: 100%;
  margin: 0;
  background-color: #0f6679;
  color: #6bb9c7;
  padding: 20px 10px;
  font-family: Arial, sans-serif;
  text-align: center;
  margin-top: 5px;
}

.footer-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1000px;
  height: 85px;
  margin: 0 auto;
  flex-wrap: wrap;

  flex-direction: row;
}

.footer-logo {
  margin-top: 10px;
  text-align: center;
  margin-left: -120px;
}

.footer-logo img {
  max-width: 200px;
  height: auto;

  margin-bottom: 5px;
}

.social-icons {
  display: flex;
  gap: 25px;
  justify-content: center;
  margin-top: -20px;
  margin-left: -40px;
}

.social-icon {
  color: #fff;
  text-decoration: none;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  border: 2.5px solid #fff;
  border-radius: 50%;
  font-size: 12px;
  transition:
    background-color 0.3s ease,
    border-color 0.3s ease;
}

.social-icon:hover {
  color: #28a745;
  background-color: #fff;
  border-color: #28a745;
}
.floginbtn button {
  margin-right: -1500px;
  padding: 12px 60px;
  font-size: 1rem;
  font-weight: bold;
  color: white;
  background-color: #28a745;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition:
    background-color 0.3s ease,
    transform 0.2s ease;
  margin-top: 25px;
}

.floginbtn button:hover {
  background-color: #218838;
  transform: scale(1.05);
}

.floginbtn button:active {
  background-color: #1e7e34;
  transform: scale(0.98);
}

.floginbtn button:focus {
  outline: 2px solid #28a745;
  outline-offset: 4px;
}
floginbtn ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.floginbtn p {
  font-size: large;
  color: white;
  font-weight: 700;
  margin: 0;
  margin-right: -1500px;
}

.footer-links {
  display: flex;
  gap: 20px;
  margin-right: 250px;
  flex-wrap: wrap;
  order: 1;
}

.footer-links a {
  margin-bottom: 40px;
  text-decoration: none;
  color: #fff;
  font-size: 1.1rem;
  transition: color 0.3s ease;
}

.footer-links a:hover {
  color: #28a745;
}

.footer-feedback {
  text-align: left;
  max-width: 300px;
  color: #fff;
  font-size: 0.9rem;
  order: 2;
}

.footer-feedback p {
  margin: 5px 0;
  margin-left: 70px;
  font-size: 1rem;
}

.feedback-button {
  padding: 10px 30px;
  font-size: 0.7rem;
  color: black;
  background-color: #28a745;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  z-index: 10;
  margin-left: 20px;
}

.feedback-button:hover {
  background-color: #218838;
}

.footer-bottom {
  margin-top: 40px;
  font-size: 0.6rem;
  margin-left: -40px;
  color: #ccc;
}
.footer-slogan {
  display: none;
}
.social-icons2 {
  display: none;
}

/* Copyright and Privacy Policy alignment */
.footer-bottom {
  width: 100%;
  box-sizing: border-box;
}

.footer-bottom-content {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
  padding: 12px 20px;
  box-sizing: border-box;
}

.footer-bottom-content p {
  margin: 0;
  text-align: center;
}

.footer-privacy-link {
  display: inline-block;
  color: #074857;
  background-color: #b0ea00;
  text-decoration: none;
  padding: 5px 12px;
  font-size: 12px;
  font-weight: 700;
  border-radius: 20px;
  transition: all 0.25s ease;
}

.footer-privacy-link:hover {
  background-color: #ffffff;
  color: #074857;
  text-decoration: none;
}

.footer-privacy-link:focus-visible {
  outline: 2px solid #ffffff;
  outline-offset: 3px;
}

@media (max-width: 768px) {
  .hide-footer-mobile {
    display: none;
  }
}

@media (max-width: 768px) {
  .footer-container {
    flex-direction: column;
    height: 100%;
    width: -40px;
    margin-left: 20px;
  }

  .footer-links {
    display: none;
    gap: 5px;
  }

  .social-icons {
    margin-top: 20px;
    margin-left: 0px;
    gap: 10px;
    margin-bottom: 20px;
  }
  .social-icon {
    color: #fff;
    text-decoration: none;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 60px;
    border: 3px solid #fff;
    border-radius: 50%;
    font-size: 12px;
    transition:
      background-color 0.3s ease,
      border-color 0.3s ease;
  }
  .footer-logo img {
    max-width: 120px;
    display: none;
  }

  .footer-bottom p {
    font-size: 0.8rem;
    margin-right: -50px;
  }

  .floginbtn button {
    width: 100%;
    padding: 10px;
    margin-right: 0px;
  }

  .floginbtn p {
    width: 100%;
    font-size: 23px;
    margin-right: 30px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer/Footer.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,cAAc;EACd,eAAe;;EAEf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;;EAEZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf;;0BAEwB;AAC1B;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf;;uBAEqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA,2CAA2C;AAC3C;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;IACT,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,qBAAqB;IACrB,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf;;4BAEwB;EAC1B;EACA;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,kBAAkB;EACpB;AACF","sourcesContent":[".footer {\n  background-color: #0d707e;\n  color: white;\n  padding: 20px 15px;\n  width: 100%;\n  margin: 0;\n  background-color: #0f6679;\n  color: #6bb9c7;\n  padding: 20px 10px;\n  font-family: Arial, sans-serif;\n  text-align: center;\n  margin-top: 5px;\n}\n\n.footer-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  max-width: 1000px;\n  height: 85px;\n  margin: 0 auto;\n  flex-wrap: wrap;\n\n  flex-direction: row;\n}\n\n.footer-logo {\n  margin-top: 10px;\n  text-align: center;\n  margin-left: -120px;\n}\n\n.footer-logo img {\n  max-width: 200px;\n  height: auto;\n\n  margin-bottom: 5px;\n}\n\n.social-icons {\n  display: flex;\n  gap: 25px;\n  justify-content: center;\n  margin-top: -20px;\n  margin-left: -40px;\n}\n\n.social-icon {\n  color: #fff;\n  text-decoration: none;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  width: 50px;\n  height: 50px;\n  border: 2.5px solid #fff;\n  border-radius: 50%;\n  font-size: 12px;\n  transition:\n    background-color 0.3s ease,\n    border-color 0.3s ease;\n}\n\n.social-icon:hover {\n  color: #28a745;\n  background-color: #fff;\n  border-color: #28a745;\n}\n.floginbtn button {\n  margin-right: -1500px;\n  padding: 12px 60px;\n  font-size: 1rem;\n  font-weight: bold;\n  color: white;\n  background-color: #28a745;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition:\n    background-color 0.3s ease,\n    transform 0.2s ease;\n  margin-top: 25px;\n}\n\n.floginbtn button:hover {\n  background-color: #218838;\n  transform: scale(1.05);\n}\n\n.floginbtn button:active {\n  background-color: #1e7e34;\n  transform: scale(0.98);\n}\n\n.floginbtn button:focus {\n  outline: 2px solid #28a745;\n  outline-offset: 4px;\n}\nfloginbtn ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.floginbtn p {\n  font-size: large;\n  color: white;\n  font-weight: 700;\n  margin: 0;\n  margin-right: -1500px;\n}\n\n.footer-links {\n  display: flex;\n  gap: 20px;\n  margin-right: 250px;\n  flex-wrap: wrap;\n  order: 1;\n}\n\n.footer-links a {\n  margin-bottom: 40px;\n  text-decoration: none;\n  color: #fff;\n  font-size: 1.1rem;\n  transition: color 0.3s ease;\n}\n\n.footer-links a:hover {\n  color: #28a745;\n}\n\n.footer-feedback {\n  text-align: left;\n  max-width: 300px;\n  color: #fff;\n  font-size: 0.9rem;\n  order: 2;\n}\n\n.footer-feedback p {\n  margin: 5px 0;\n  margin-left: 70px;\n  font-size: 1rem;\n}\n\n.feedback-button {\n  padding: 10px 30px;\n  font-size: 0.7rem;\n  color: black;\n  background-color: #28a745;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  z-index: 10;\n  margin-left: 20px;\n}\n\n.feedback-button:hover {\n  background-color: #218838;\n}\n\n.footer-bottom {\n  margin-top: 40px;\n  font-size: 0.6rem;\n  margin-left: -40px;\n  color: #ccc;\n}\n.footer-slogan {\n  display: none;\n}\n.social-icons2 {\n  display: none;\n}\n\n/* Copyright and Privacy Policy alignment */\n.footer-bottom {\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.footer-bottom-content {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  padding: 12px 20px;\n  box-sizing: border-box;\n}\n\n.footer-bottom-content p {\n  margin: 0;\n  text-align: center;\n}\n\n.footer-privacy-link {\n  display: inline-block;\n  color: #074857;\n  background-color: #b0ea00;\n  text-decoration: none;\n  padding: 5px 12px;\n  font-size: 12px;\n  font-weight: 700;\n  border-radius: 20px;\n  transition: all 0.25s ease;\n}\n\n.footer-privacy-link:hover {\n  background-color: #ffffff;\n  color: #074857;\n  text-decoration: none;\n}\n\n.footer-privacy-link:focus-visible {\n  outline: 2px solid #ffffff;\n  outline-offset: 3px;\n}\n\n@media (max-width: 768px) {\n  .hide-footer-mobile {\n    display: none;\n  }\n}\n\n@media (max-width: 768px) {\n  .footer-container {\n    flex-direction: column;\n    height: 100%;\n    width: -40px;\n    margin-left: 20px;\n  }\n\n  .footer-links {\n    display: none;\n    gap: 5px;\n  }\n\n  .social-icons {\n    margin-top: 20px;\n    margin-left: 0px;\n    gap: 10px;\n    margin-bottom: 20px;\n  }\n  .social-icon {\n    color: #fff;\n    text-decoration: none;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    width: 60px;\n    height: 60px;\n    border: 3px solid #fff;\n    border-radius: 50%;\n    font-size: 12px;\n    transition:\n      background-color 0.3s ease,\n      border-color 0.3s ease;\n  }\n  .footer-logo img {\n    max-width: 120px;\n    display: none;\n  }\n\n  .footer-bottom p {\n    font-size: 0.8rem;\n    margin-right: -50px;\n  }\n\n  .floginbtn button {\n    width: 100%;\n    padding: 10px;\n    margin-right: 0px;\n  }\n\n  .floginbtn p {\n    width: 100%;\n    font-size: 23px;\n    margin-right: 30px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
